export const GET_MEDICA_STANDINGS = "PublicPages/GET_MEDICA_STANDINGS";
export const GET_MEDICA_STANDINGS_SUCCESSFUL = "PublicPages/GET_MEDICA_STANDINGS_SUCCESSFUL";
export const GET_MEDICA_STANDINGS_FAILED = "PublicPages/GET_MEDICA_STANDINGS_FAILED";
